import { render, staticRenderFns } from "./normalUserDetails.vue?vue&type=template&id=28f05cf0&scoped=true"
import script from "./normalUserDetails.vue?vue&type=script&lang=js"
export * from "./normalUserDetails.vue?vue&type=script&lang=js"
import style0 from "./normalUserDetails.vue?vue&type=style&index=0&id=28f05cf0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f05cf0",
  null
  
)

export default component.exports